<template>
  <section class="mention-individual-tag">
    <div class="tag" :class="{'relation-tag': relationTag, [tagClass]: tagClass}" :style="`background-color: ${mention.is_private ? 'orange' : mention.color}`">
      <span>{{ mentionName }}</span>
      <div v-if="showScoringSystem && mention.show_sentiment" class="sentiment-wrapper">
        <span class="sentiment positive align-center">
          {{ getTagScore(mention, true) }}
        </span>
        <span class="sentiment negative align-center">
          {{ getTagScore(mention, false) }}
        </span>
      </div>
    </div>

    <div v-if="relationTag" class="tag" :style="`background-color: ${relationTag.color}`">
      <span>{{ relationTag.name }}</span>
      <div v-if="showScoringSystem && relationTag.show_sentiment" class="sentiment-wrapper">
        <span class="sentiment positive align-center">
          {{ getTagScore(relationTag, true) }}
        </span>
        <span class="sentiment negative align-center">
          {{ getTagScore(relationTag, false) }}
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    name: 'mention-individual',
    props: {
        mention: Object,
        showScoringSystem: {
          type: Boolean,
          default: false
        },
        tagClass: String
    },
    computed: {
      relationTag () {
        return this.mention && this.mention.relation_tag;
      },
      mentionName () {
        let name = this.mention && this.mention.name;

        if (this.mention && this.mention.hasOwnProperty('active') && !this.mention.active) {
          name += ' (Inactive)';
        }

        return name;
      }
    },
    methods: {
      getTagScore(tag, positive) {
        const score = positive ? tag.positive_score || 0 : tag.negative_score || 0;
        return score;
      }
    }
};
</script>

<style lang="scss" scoped>
@import "../../styles/components/coding-admin/tags.scss";
</style>